// libs
import React from 'react';
import { Badge } from 'framework/ui/mui-builder';
// components
import { FieldProps, TextField, useFieldHelper } from 'framework/ui/field';
// services
import useFinanceService from 'domain/people/employee/finance/shared/financeService';
import { Typography } from '@mui/material';

const FinancePackageIdField = ({ source, ...props }: FieldProps) => {
  const { getValue } = useFieldHelper({ source });
  const { dateFromSource, dateToSource, probationAmountSource } = props;
  const { getValue: getDateFromValue } = useFieldHelper({ source: dateFromSource });
  const { getValue: getDateToValue } = useFieldHelper({ source: dateToSource });
  const { getValue: getProbationAmountValue } = useFieldHelper({ source: probationAmountSource });
  const { getIsCurrentPackage } = useFinanceService();
  const value = getValue();

  const getBadges = () => {
    const badgesBlock = [];
    const effectiveDateFrom = getDateFromValue();
    const effectiveDateTo = getDateToValue();
    const probationAmount = getProbationAmountValue();
    const showCurrent = getIsCurrentPackage({ effectiveDateFrom, effectiveDateTo });

    if (showCurrent) {
      badgesBlock.push(
        <Badge color="success" sx={{ mr: 1 }} key="current">
          Current
        </Badge>,
      );
    }

    if (probationAmount) {
      badgesBlock.push(
        <Badge color="primary" key="probation">
          Probation
        </Badge>,
      );
    }

    return badgesBlock;
  };

  const getFieldValue = () => {
    return (
      <>
        <Typography component="span" mr={1}>
          {value}
        </Typography>
        {getBadges()}
      </>
    );
  };

  return <TextField value={getFieldValue()} {...props} />;
};

export default FinancePackageIdField;
